<template>
  <div class="registered_number">
    <div class="query_wapper">
      <div class="query_item">
        <el-select
          @change="getList"
          style="width:200px;"
          placeholder="按等级查询"
          :popper-append-to-body="false"
          clearable
          v-model="query.refereeRank"
        >
          <el-option value="国际级" label="国际级"></el-option>
          <el-option value="国家级" label="国家级"></el-option>
          <el-option value="荣誉级" label="荣誉级"></el-option>
          <el-option value="一级" label="一级"></el-option>
          <el-option value="二级" label="二级"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px;"
          @keyup.enter.native="getList"
        >
          <el-button class="search_btn" slot="append" @click="getList">查询</el-button>
        </el-input>
      </div>
      <div class="query_item">
        <el-button
          style="width:90px;padding:12px 0;text-align:center;margin:0 10px 0 0;"
          type="primary"
          @click="exportExcel"
        >导出EXCEL</el-button>
        <el-button style="width:90px" type="warning" @click="print">打印</el-button>
      </div>
    </div>
    <div class="titles">
      <p>年度在册裁判员数量统计表</p>
      <p>
        共
        <span>{{totalList.length > 0?totalList.length - 1:0}}</span>条数据
      </p>
    </div>
    <div class="print_table_box">
      <table
        v-for="(n,t) in showNum"
        :key="t"
        class="print_table"
        cellspacing="0"
        cellpadding="0"
        style="width:100%;
            table-layout: fixed;
            border-top:1px solid #e9eaec;
            border-left: 1px solid #e9eaec;"
      >
        <thead>
          <template v-for="(item,index) in printColumns">
            <th :style="{width:item.width + 'px'}" :key="index">{{item.title}}</th>
          </template>
        </thead>
        <tbody>
          <template v-for="(item,index) in printTable.slice(26 * t,26 * (t + 1))">
            <tr style="text-align:center" class="unit" :key="index">
              <td style="line-height:46px;" v-if="(index + 1) % 2 !== 0" rowspan="2">
                <p>{{item.name}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?'女':'男'}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count08:item.count18}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count010:item.count110}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count07:item.count17}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count09:item.count19}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count04:item.count14}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count05:item.count15}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count01:item.count11}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count06:item.count16}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count03:item.count13}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.count02:item.count12}}</p>
              </td>
              <td>
                <p>{{item.gender === 'girl'?item.countAll0:item.countAll1}}</p>
              </td>
              <td v-if="(index + 1) % 2 !== 0" rowspan="2">
                <p>{{item.countAll}}</p>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <el-table :span-method="objectSpanMethod" :data="tableData" border style="margin-top:20px">
      <el-table-column label="学校名称" prop="name" align="center" min-width="160">
        <template slot-scope="{row,$index}">
          <span
            :style="{fontSize:(tableData.length - 2) === $index?'18px':'',fontWeight:(tableData.length - 2) === $index?'bold':''}"
          >{{row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="性别" width="60" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?'女':'男'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="篮球" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count08:row.count18}}</span>
        </template>
      </el-table-column>
      <el-table-column label="排球" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count010:row.count110}}</span>
        </template>
      </el-table-column>
      <el-table-column label="足球" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count07:row.count17}}</span>
        </template>
      </el-table-column>
      <el-table-column label="田径" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count09:row.count19}}</span>
        </template>
      </el-table-column>
      <el-table-column label="游泳" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count04:row.count14}}</span>
        </template>
      </el-table-column>
      <el-table-column label="羽毛球" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count05:row.count15}}</span>
        </template>
      </el-table-column>
      <el-table-column label="网球" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count01:row.count11}}</span>
        </template>
      </el-table-column>
      <el-table-column label="乒乓球" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count06:row.count16}}</span>
        </template>
      </el-table-column>
      <el-table-column label="健美操" width="100" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count03:row.count13}}</span>
        </template>
      </el-table-column>
      <el-table-column label="武术（跆拳道）" width="120" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.count02:row.count12}}</span>
        </template>
      </el-table-column>
      <el-table-column label="男女人数" width="120" align="center">
        <template slot-scope="{row}">
          <span>{{row.gender === 'girl'?row.countAll0:row.countAll1}}</span>
        </template>
      </el-table-column>
      <el-table-column label="队伍人数" width="120" align="center">
        <template slot-scope="{row,$index}">
          <span
            :style="{fontSize:(tableData.length - 2) === $index?'18px':'',fontWeight:(tableData.length - 2) === $index?'bold':''}"
          >{{row.countAll}}</span>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="total"
    >合计：{{totalList.length > 0?totalList[totalList.length - 1].countAll:0}} 人，其中男 {{totalList.length > 0?totalList[totalList.length - 1].countAll1:0}} 人，女 {{totalList.length > 0?totalList[totalList.length - 1].countAll0:0}} 人。</div>
  </div>
</template>
<script>
import { getRefereeCountList } from "@/api/judge.js";
import { message, table, page } from "@/common/js/mixins.js";
import { baseUrl } from "@/utils/config";
export default {
  mixins: [message, table, page],
  data() {
    return {
      totalList: [],
      query: {
        refereeRank: "",
        keyword: ""
      },
      printColumns: [
        {
          title: "学校名称"
        },
        {
          title: "性别",
          width: 50
        },
        {
          title: "篮球",
          width: 60
        },
        {
          title: "排球",
          width: 60
        },
        {
          title: "足球",
          width: 60
        },
        {
          title: "田径",
          width: 60
        },
        {
          title: "游泳",
          width: 60
        },
        {
          title: "羽毛球",
          width: 60
        },
        {
          title: "网球",
          width: 60
        },
        {
          title: "乒乓球",
          width: 60
        },
        {
          title: "健美操",
          width: 60
        },
        {
          title: "武术（跆拳道）",
          width: 114
        },
        {
          title: "男女人数",
          width: 100
        },
        {
          title: "队伍人数",
          width: 100
        }
      ],
      printTable: []
    };
  },
  computed:{
      showNum(){
          if(this.printTable.length === 0) {
              return 0;
          }
          if(this.printTable.length < 26) {
              return 1
          }
          else {
              let num = 1;
              for(let i = 0; i < this.printTable.length;i++) {
                  if((i + 1) % 26 === 0) num++; 
              }
              if(this.printTable.length - (26 * num) > 0) {
                  i++;
              }
              return num;
          }
      }
  },
  methods: {
    // 获取列表
    getList() {
      getRefereeCountList({
        ...this.query
      })
        .then(res => {
          let arr = [];
          this.totalList = [...res];
          res.filter(item => {
            let girl = {};
            let boy = {};
            for (let temp in item) {
              if (temp.split("count")[1] - 0 <= 10) {
                girl[temp] = item[temp];
              } else {
                boy[temp] = item[temp];
              }
              if (isNaN(temp.split("count")[1] - 0)) {
                girl[temp] = item[temp];
                boy[temp] = item[temp];
              }
            }
            girl.gender = "girl";
            boy.gender = "boy";
            arr.push(boy, girl);
          });

          this.tableData = arr;
        })
        .catch(err => {});
    },
    // 导出表格
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      window.location.href =
        baseUrl + "/statistics/downloadRefereeCountList?" + params.join("&");
    },
    // 打印
    async print() {
      let list = await getRefereeCountList({
        ...this.query,
        pageNo: 1,
        pageSize: 9999
      });
      this.printTable = [];
      
      list.filter(item => {
        let girl = {};
        let boy = {};
        for (let temp in item) {
          if (temp.split("count")[1] - 0 <= 10) {
            girl[temp] = item[temp];
          } else {
            boy[temp] = item[temp];
          }
          if (isNaN(temp.split("count")[1] - 0)) {
            girl[temp] = item[temp];
            boy[temp] = item[temp];
          }
        }
        girl.gender = "girl";
        boy.gender = "boy";
        this.printTable.push(boy, girl);
      });

      // 调用公共方法打印（方法在mixins.js)
      this.$nextTick(() => {
        var el = document.querySelector(".print_table_box"),
          iframe = document.createElement("IFRAME"),
          doc = null;

        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          '<html><head><style type="text/css" media="all">@page {size: landscape; margin: 0mm 8mm;} .print_table {page-break-after:always;table-layout: fixed;width: 100%;margin:50px 0 0 0}.print_table th {min-width: 0;text-align:center;height: 48px;box-sizing: border-box;border-bottom: 1px solid #e9eaec;border-right: 1px solid #e9eaec;text-overflow: ellipsis;vertical-align: middle;white-space: nowrap;overflow: hidden;}.print_table tbody td {border: 1px solid #e9eaec;border-top: none;border-left: none;min-width: 0;height: 30px;box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;}</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );
        doc.close();
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      });
    },
    //
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 13) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.registered_number {
  position: relative;
  .titles {
    display: flex;
    align-items: center;
    font-size: 22px;
    > p {
      display: flex;
      align-items: center;
      &:first-of-type {
        margin-right: 20px;
      }
      &:last-of-type {
        font-size: 14px;
        > span {
          color: #fd6666;
        }
      }
    }
  }
  .total {
    display: flex;
    align-items: center;
    margin-top: 20px;
    color: #333;
  }
  .print_table_box {
    position: absolute;
    left: -50000px;
    top: -10000px;
    .print_table {
      > tbody {
        > tr > td > p {
          box-sizing: border-box;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          word-break: break-all;
          line-height: 23px;
        }
      }
    }
  }
}
</style>